<template>
  <v-dialog
    v-model="value"
    @input="v => v || closeAction()"
    max-width="500px"
    :persistent="true"
    @show="fetchFleets"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{
          mode === "edit" ? $t("editVehicle") : $t("createVehicle")
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-text-field
            name="name"
            :label="$t('name')"
            type="text"
            v-model="vehicle.name"
            v-validate="'required|max:255'"
            :data-vv-as="$t('name')"
            :error-messages="errors.collect('name')"
          ></v-text-field>

          <v-text-field
            name="consel_id"
            :label="$t('consel_id')"
            type="text"
            v-model="vehicle.consel_id"
            v-validate="'required'"
            :data-vv-as="$t('consel_id')"
            :error-messages="errors.collect('consel_id')"
          ></v-text-field>

          <au-date-time-picker
            v-model="vehicle.started_service_at"
            name="started_service_at"
            :label="$t('vehicleStartedServiceAt')"
            required
            max-today
          />

          <v-select
  name="fleet"
  :label="$t('fleet')"
  v-model="vehicle.fleet"
  v-validate="'required'"
  :data-vv-as="$t('fleet')"
  :items="fleets"
  :total-items="fleetsCount"
  :loading="fleetIsLoading"
  :error-messages="errors.collect('fleet')"
  item-text="name"
  item-value="id"  
></v-select>


        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          flat
          @click.native="closeAction"
          :disabled="formDisabled"
          >{{ $t("close") }}</v-btn
        >
        <v-btn
          color="blue darken-1"
          flat
          @click.native="saveAction"
          :disabled="formDisabled"
          >{{ $t("save") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  UPDATE_VEHICLE,
  CREATE_VEHICLE,
  RESET_VEHICLE,
  SHOW_SNACKBAR,
  FETCH_FLEETS
} from "@/store/actions.type";
import validationErrorsMixin from "@/mixins/validationErrors.mixin";

export default {
  props: {
    value: Boolean,
    mode: String
  },
  data() {
    return {
      formDisabled: false,
    };
  },
  computed: {
    ...mapGetters([
      "vehicle",
      "fleets",
      "fleetsCount",
      "fleetIsLoading"
    ])
  },
  mixins: [validationErrorsMixin],
  methods: {
    saveAction() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.formDisabled = true;
          this.$store
            .dispatch(
              this.mode === "edit" ? UPDATE_VEHICLE : CREATE_VEHICLE,
              this.vehicle
            )
            .then(() => {
              this.$store.dispatch(SHOW_SNACKBAR, {
                text: this.$t("savedSuccessfully", [this.$t("vehicle")]),
                color: "success"
              });
              this.closeAction();
              this.$emit("saved");
            })
            .catch(() => {
              this.formDisabled = false;
            });
        }
      });
    },
    closeAction() {
      this.$emit("input", false);
      this.formDisabled = false;
      // Wait for the animation to finish
      setTimeout(() => {
        this.$store.dispatch(RESET_VEHICLE);
      }, 100);
    }
  },
  mounted() {
    // Fetch fleets when the component is mounted
    this.$store.dispatch(FETCH_FLEETS);
  }
};
</script>

<style scoped></style>
